import { createViewerAction } from "../../core/make-action";
import ViewerMethod from "../../core/ViewerMethod";

export const scrollToStartLocation = createViewerAction(
  ViewerMethod.SCROLL_TO_START_LOCATION
);
